import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectAccounts = createSelector(
  [(state: RootState) => state.account.accounts],
  (accounts) => accounts
);
